import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { EanStatus, ProfileListItem } from 'src/app/shared/services/backend'
import { AssociatedUsers } from '../models/associated-users.model'
import { InstallationDetails } from '../models/installation-details.model'
import { InstallationItem } from '../models/installation-item.model'
import { PaymentDetails } from '../models/payment-details.model'

@Injectable({
    providedIn: 'root',
})
export class ProfileStateService {
    private selectedInstallation = new BehaviorSubject<InstallationItem | null>(null)
    private installations = new BehaviorSubject<Array<ProfileListItem> | null>(null)
    private associatedUsers = new BehaviorSubject<AssociatedUsers | null>(null)
    private paymentDetails = new BehaviorSubject<PaymentDetails | null>(null)
    private installationDetails = new BehaviorSubject<InstallationDetails | null>(null)
    private supplierName = new BehaviorSubject<string | null>(null)
    private customerNumber = new BehaviorSubject<string | null>(null)
    private eanStatus = new BehaviorSubject<EanStatus | null>(null)

    public selectedInstallation$ = this.selectedInstallation.asObservable()
    public installations$ = this.installations.asObservable()
    public associatedUsers$ = this.associatedUsers.asObservable()
    public paymentDetails$ = this.paymentDetails.asObservable()
    public installationDetails$ = this.installationDetails.asObservable()
    public supplierName$ = this.supplierName.asObservable()
    public customerNumber$ = this.customerNumber.asObservable()
    public eanStatus$ = this.eanStatus.asObservable()

    setSelectedInstallation(installation: InstallationItem) {
        if (installation && installation.selectedInstallation) {
            this.selectedInstallation.next(installation)
        }
    }

    setInstallations(installations: Array<ProfileListItem> | null) {
        this.installations.next(installations)
    }

    setAssociatedUsers(associatedUsers: AssociatedUsers | null) {
        this.associatedUsers.next(associatedUsers)
    }

    setPaymentDetails(paymentDetails: PaymentDetails | null) {
        this.paymentDetails.next(paymentDetails)
    }

    setInstallationDetails(installationDetails: InstallationDetails | null) {
        this.installationDetails.next(installationDetails)
    }

    setSupplierName(supplierName: string | null) {
        this.supplierName.next(supplierName)
    }

    setCustomerNumber(customerNumber: string | null, onlyIfUnset: boolean = false) {
        if ((onlyIfUnset && this.customerNumber.value === null) || !onlyIfUnset) {
            this.customerNumber.next(customerNumber)
        }
    }

    setEanStatus(eanStatus: EanStatus | null) {
        this.eanStatus.next(eanStatus)
    }
}
